<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WkInstitutionBaseSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const module = ref<string>('wk-institutions');
const defaults = ref<any>({
    content: null,
    institutionsPage: null
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            institutionsPage: schema.number().nullable()
                .required($t('[[[Wybieranie strony jest wymagane]]]'))
                .typeError($t('[[[Wybieranie strony jest wymagane]]]'))
        })
    }));
}
onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Treść]]]')" :invalid-feedback="form.$errors.first('settings.content')" :state="form.$errors.state('settings.content')">
        <Editor id="editorContent" v-model="form.settings.content" />
    </IdeoFormGroup>

    <IdeoFormGroup :label="$t('[[[Wybór strony]]]')" :invalid-feedback="form.$errors.first('settings.institutionsPage')" :state="form.$errors.state('settings.institutionsPage')" required>
        <EditoPageSelector v-model="form.settings.institutionsPage" :module="module" label="" :preview="false" class="mb-0" />
    </IdeoFormGroup>
</template>
